import { Search } from '@/DTOS/AccessControlEntry/Search';
import request from '../../utils/request';

const AccessControlEntryService = {
  report: (search: Search) => {
    return request('/accessControlEntry/report', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  print: (specification: Search) => {
    return request(
      '/accessControlEntry/print',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request: { ...specification } }),
      },
      true
    );
  },
};

export default AccessControlEntryService;
